var Flickity = require('flickity');
var imagesLoaded = require('flickity-imagesloaded');

var slideshows = document.querySelectorAll('.slideshow');

for (var i = 0; i < slideshows.length; i += 1) {
  const alt = slideshows[i].classList.contains('slideshow--alt');

  let config = {
    autoPlay: 6000,
    draggable: false,
    imagesLoaded: true,
    contain: true,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
  }

  if (alt) {
    config = {
      imagesLoaded: true,
      contain: true,
      wrapAround: true,
      pageDots: false,
    }
  }

  var flkty = new Flickity(slideshows[i], config);
}
